
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * EmployeeESSUserLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EmployeeESSUserLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<string[]> {
        return this.$apiService.sendAuth("IEmployeeESSUserLookupService/Lookup", pCriteria);
    }
}
